import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { AffiliateHeader, AffiliateFooter } from '../components/affiliate/AffiliateChrome';
import { CONTACT_INFO } from '../data/branding';

const ContactPage = () => (
  <div className="min-h-screen bg-neutral-950 text-white">
    <AffiliateHeader />
    <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <p className="text-xs uppercase tracking-widest text-axon-500 font-semibold">Contact us</p>
      <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-3">Affiliate program support</h1>
      <p className="text-neutral-400 mb-10">Questions about your application, your link, or your commissions? Reach out and a real human will get back to you.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <a href={`mailto:${CONTACT_INFO.email}`} className="p-6 rounded-2xl bg-neutral-900/60 border border-neutral-800 hover:border-axon-500 transition-colors">
          <Mail className="w-6 h-6 text-axon-500 mb-3" />
          <p className="text-xs uppercase tracking-wider text-neutral-400">Email</p>
          <p className="font-semibold break-all">{CONTACT_INFO.email}</p>
        </a>
        <a href={`tel:${CONTACT_INFO.phone.replace(/\D/g, '')}`} className="p-6 rounded-2xl bg-neutral-900/60 border border-neutral-800 hover:border-axon-500 transition-colors">
          <Phone className="w-6 h-6 text-axon-500 mb-3" />
          <p className="text-xs uppercase tracking-wider text-neutral-400">Phone</p>
          <p className="font-semibold">{CONTACT_INFO.phone}</p>
        </a>
        <div className="p-6 rounded-2xl bg-neutral-900/60 border border-neutral-800">
          <MapPin className="w-6 h-6 text-axon-500 mb-3" />
          <p className="text-xs uppercase tracking-wider text-neutral-400">Address</p>
          <p className="text-sm leading-relaxed">
            {CONTACT_INFO.address.street}<br />
            {CONTACT_INFO.address.city}, {CONTACT_INFO.address.state} {CONTACT_INFO.address.zip}
          </p>
        </div>
      </div>
    </section>
    <AffiliateFooter />
  </div>
);

export default ContactPage;
